export default {
  translations: state => state.translations,
  serviceElementTranslations: state => state.serviceElementTranslations,
  languages: state => state.languages,
  customMessageTranslations: state => state.customMessageTranslations
}



// WEBPACK FOOTER //
// ./src/store/modules/translation/getters.js